const translations = {
    delete: 'Delete',
    fileTooLargeError: 'File Exceeds Max Size of 20MB',
    multipleFiles: '{{count}} Files',
    tooManyFiles:
        "Too Many Files Selected. Max file upload is {{maxFiles}} files. You've selected {{count}} files."
};

export default translations;
